import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import Swiper from 'swiper';
import { Autoplay, Navigation, Scrollbar, Pagination } from 'swiper/modules';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { getScrollLookup } from './getScrollLookup';
import fitty from 'fitty';

// Swiper
import 'swiper/css';
import 'swiper/css/scrollbar';
window.Swiper = Swiper;
Swiper.use([Autoplay, Navigation, Scrollbar, Pagination]);

// GSAP
window.gsap = gsap;
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
window.ScrollTrigger = ScrollTrigger;
window.getScrollLookup = getScrollLookup;

// Alpine
window.Alpine = Alpine;
Alpine.plugin(collapse);

// Fitty
window.fitty = fitty;

// Init Alpine after page load
document.addEventListener('DOMContentLoaded', () => {
	Alpine.start();
});
